import React, { useState } from "react";
import { IoInformationCircleSharp } from "react-icons/io5";

export const Tooltip = ({ tooltip }) => {
  const [showPopup, setShowPopup] = useState(false);
  return (
    <div>
      <div
        className=" absolute left-8 top-[50%] -translate-y-[50%]"
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() =>
          setTimeout(() => {
            setShowPopup(false);
          }, 500)
        }
      >
        <IoInformationCircleSharp />
      </div>
      {showPopup && (
        <div className="z-10 absolute rounded-lg bg-black bg-opacity-80 p-2 text-white text-[10px]">
          {tooltip}
        </div>
      )}
    </div>
  );
};
